import React from 'react';

import css from './TopbarSearchForm.module.css';

const IconSearchDesktop = () => (
  <svg
    className={css.iconSvg}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9138 6.25736C12.5706 3.91421 8.77165 3.91421 6.4285 6.25736C4.08536 8.6005 4.08536 12.3995 6.4285 14.7426C8.77165 17.0858 12.5706 17.0858 14.9138 14.7426C17.2569 12.3995 17.2569 8.6005 14.9138 6.25736ZM5.36784 5.1967C8.29677 2.26777 13.0455 2.26777 15.9744 5.1967C18.9034 8.12563 18.9034 12.8744 15.9744 15.8033C13.0455 18.7322 8.29677 18.7322 5.36784 15.8033C2.43891 12.8744 2.43891 8.12563 5.36784 5.1967Z"
      fill="#656566"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.1866 20.7222L15.0601 15.5957L16.1208 14.535L21.2473 19.6616L20.1866 20.7222Z"
      fill="#656566"
    />
  </svg>
);

export default IconSearchDesktop;
